//constants
import {
  VERIFY_EMAIL_SETTINGS_ACTION,
  VERIFY_OTP_SETTINGS_ACTION,
  SEND_OTP_SETTING_ACTION,
  GET_PROFILE_SETTING_ACTION,
} from "./Constants";

const INITIAL_STATE = {
  error: null,
  data: null,
  profileInfo: {},
};
export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case VERIFY_EMAIL_SETTINGS_ACTION:
      return {
        ...state,
        error: action.error,
        data: action.data,
      };
    case VERIFY_OTP_SETTINGS_ACTION:
      return {
        ...state,
        error: action.error,
        data: action.data,
      };
    case SEND_OTP_SETTING_ACTION:
      return {
        ...state,
        error: action.error,
        data: action.data,
      };
    case GET_PROFILE_SETTING_ACTION:
      return {
        ...state,
        error: action.error,
        profileInfo: action.data ? { ...action.data } : null,
      };

    default:
      return state;
  }
}
